module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/en-企业社会责任.1584af0c.png";